/**
 * Click-to-call (C2C) reference types for call-log mapping.
 * Each screen / card must pass its own unique type — do not reuse another surface’s value.
 *
 * Mapping doc: https://vahak.atlassian.net/wiki/spaces/PR/pages/789938177/Call+logs+mapping
 * Numeric ids are offset by +1000 from the original wiki sequence.
 *
 * When adding a new click-to-call CTA:
 * 1. Add a new enum member (never reuse an existing id for a different screen)
 * 2. Use that member only from that screen/card
 *
 * Ticket system: always pass ticket_id as reference_id with TICKET_SYSTEM as reference_type.
 */

export enum C2C_REFERENCE_TYPE {
    // —— Core entities ——
    LOAD = 1001,
    LORRY = 1002,
    NETWORK = 1003,

    // —— Transactions ——
    TRANSACTION_LOAD_BID = 1005,
    TRANSACTION_LORRY_BID = 1006,

    // —— My bids (consumer marketplace lists) ——
    LOAD_MY_BID_RECEIVED = 1007,
    LOAD_MY_BID_SENT = 1008,
    LORRY_MY_BID_RECEIVED = 1009,
    LORRY_MY_BID_SENT = 1010,

    // —— Profile / directory ——
    PROFILE = 1011,
    TRANSPORT_DIRECTORY = 1012,
    PROFILE_BIDDER_KAM = 1013,
    PROFILE_USER_BASIC_INFO = 1014,
    TRANSPORT_DIRECTORY_CARD = 1015,

    // —— TSO / tagged user ——
    AGENT_LOAD = 1020,
    TAGGED_USER_LOAD_BID = 1021,
    TAGGED_USER_LOAD_ENQUIRY_CARD = 1022,
    TAGGED_USER_LOAD_LIVE_LORRY = 1023,
    TAGGED_USER_LORRY_LIVE_LOAD = 1024,
    ASSURED_LOAD_TAGGED_LIVE_LORRY = 1025,
    TAGGED_USER_DETAIL_SCREEN = 1026,
    TSO_LOAD_POSTED_SCREEN = 1027,
    TSO_LORRY_POSTED_SCREEN = 1028,
    TAGGED_USER_LOAD_PAST_TRANSACTOR = 1029,
    TAGGED_USER_LOAD_MY_BID = 1030,
    TAGGED_USER_LOAD_EXPIRED_LORRY = 1031,
    TAGGED_USER_LOAD_LIVES = 1032,
    AGENT_LORRY = 1033,
    TAGGED_USER_LORRY_MY_BID = 1035,

    // —— Consumer marketplace ——
    LOAD_MARKETPLACE = 1036,
    LORRY_MARKETPLACE = 1037,

    // —— Load details / in-transit ——
    IN_TRANSIT_STATUS_TRACKING = 1038,

    // —— Admin ticket system (common for all ticket screens/cards) ——
    TICKET_SYSTEM = 1040
}
